export default __webpack_public_path__ + "static/media/BUSM.8bee77f7.png";